export const TOAST_ERROR = 'error';
export const TOAST_WARNING = 'warning';
export const TOAST_SUCCESS = 'success';
export const TOAST_INFO = 'info';
